// Ported from LC2's CommunityPerformance.js (commons/components/HomeTabs/Performance/) —
// same "days on market, then concessions" composition. LC2 also had `ConcessionComps` and
// `Delinquency` commented out here (not something this port disabled — both were already
// inactive in LC2), so they're left out here too.
import React from 'react';
import {Stack} from '@mui/material';

import DaysOnMarket from './DaysOnMarket';
import UnitsWithConcessions from './UnitsWithConcessions';

const CommunityPerformance = () => (
    <Stack direction="column" rowGap={2} sx={{width: '100%'}}>
        <DaysOnMarket />
        <UnitsWithConcessions />
    </Stack>
);

export default CommunityPerformance;
